module.exports = __webpack_public_path__ + "images/a4-landscape-524c26b8352e7da37a1dbe3f47eedec7.jpg";